import { colors } from '../../../shared/styles/baseStyle';

const styles = {
  progressContainerRow: {
    marginBottom: 16
  },
  consumedText: {
    fontSize: 12
  },
  rowInfo: {
    border: '1px solid #e8e8e8',
    borderRadius: 8,
    padding: '10px 14px'
  },
  infoIcon: {
    color: colors.anytimeViolet,
    fontSize: 16,
    marginRight: 10
  }
};

export default styles;
